export default [
  {
    path: '/imagens-home',
    name: 'imagens-home-list',
    component: () => import('@/views/cadastros/imagens-home/list/Index.vue'),
    meta: {
      pageTitle: 'Imagens Home',
      actions: 'read',
      resource: 'AdminHanes',
    },
  },
  {
    path: '/imagens-home/novo',
    name: 'imagens-home-novo',
    component: () => import('@/views/cadastros/imagens-home/edit/NewImagemHome.vue'),
    meta: {
      pageTitle: 'Nova Imagem Home',
      breadcrumb: [
        {
          text: 'Imagens Home',
          to: '/imagens-home',
        },
        {
          text: 'Novo',
          active: true,
        },
      ],
      actions: 'read',
      resource: 'AdminHanes',
    },
  },
  {
    path: '/imagens-home/edit/:id',
    name: 'imagens-home-edit-id',
    component: () => import('@/views/cadastros/imagens-home/edit/EditImagemHome.vue'),
    meta: {
      pageTitle: 'Nova Imagem Home',
      breadcrumb: [
        {
          text: 'Imagens Home',
          to: '/imagens-home',
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
      actions: 'read',
      resource: 'AdminHanes',
    },
  },
];
